// extracted by mini-css-extract-plugin
export default {"question":"style_question__SJ5iF","choices":"style_choices__1dhpJ"};